// src/components/latest-results/LatestResultsTableHeader.jsx
export default function LatestResultsTableHeader() {
    return (
      <div className="flex w-full h-16 border-b my-2 border-[#845BB3]">
        <div className="flex-grow-[3] border-r flex items-center justify-center border-[#845BB3]">
          Test Name
        </div>
        <div className="flex-grow border-r flex items-center justify-center border-[#845BB3]">
          Result
        </div>
        <div className="flex-grow border-r flex items-center justify-center border-[#845BB3]">
          Unit & Range
        </div>
        <div className="flex-grow flex items-center justify-center">
          Fetch Result
        </div>
      </div>
    );
  }
  